"use strict";

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrayTextArea = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

exports.ArrayTextArea = react_1.default.forwardRef(function (_a, outerRef) {
  var value = _a.value,
      _onChange = _a.onChange,
      props = __rest(_a, ["value", "onChange"]);

  var _ref = react_1.default.useRef();

  var _react_1$default$useS = react_1.default.useState((value === null || value === void 0 ? void 0 : value.join('\n')) || ''),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      localValue = _react_1$default$useS2[0],
      setLocalValue = _react_1$default$useS2[1];

  var focusRef = react_1.default.useRef(false);
  react_1.default.useEffect(function () {
    if (!focusRef.current) {
      setLocalValue((value === null || value === void 0 ? void 0 : value.join('\n')) || '');
    }
  }, [value]);
  return react_1.default.createElement(antd_1.Input.TextArea, Object.assign({}, props, {
    ref: function ref(c) {
      if (typeof outerRef === 'function') {
        outerRef(c);
      } else if (outerRef) {
        outerRef.current = c;
      }

      _ref.current = c;
    },
    value: localValue,
    onFocus: function onFocus() {
      return focusRef.current = true;
    },
    onBlur: function onBlur() {
      return focusRef.current = false;
    },
    onChange: function onChange(e) {
      setLocalValue(e.target.value);

      if (_onChange) {
        _onChange(e.target.value.split('\n').map(function (s) {
          return s.trim();
        }).filter(Boolean));
      }
    }
  }));
});